import { useState } from 'react'
import { constructOptionMultipleSelect } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_BRAND } from 'services/apiBrand'
import { ProductHighlight } from 'components/product/brand-create/product-highlight/ProductHighlight'

export const ProductHighlightContainer = ({ brandDetail, onChangeForm, id }) => {
    const { fetching: getProductList } = useFetch({ ...API_BRAND.PRODUCT_LIST, initPathVariable: id })
    const [optionsProduct, setOptionsProduct] = useState([])

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'name', 'id', 'product_image_url')
            setOptionsProduct(newList)
        })
    }

    const props = {
        brandDetail,
        onSearchProduct,
        optionsProduct,
        onChangeForm,
    }

    return <ProductHighlight {...props} />
}
